import { Select } from 'antd';
import React from 'react';

interface ICustomSelectProps {
    placeholder?: string;
    listClients?: any;
    getUsersFromSelect: (data: string[]) => void;
    Selectvalue?: any[];
}

const CustomSelect = (props: ICustomSelectProps) => {
    const { placeholder = 'Destinataires', getUsersFromSelect, listClients, Selectvalue } = props;

    // Handle user list state
    const handleChange = (value: any[]) => {
        getUsersFromSelect(value);
    };

    return (
        <Select
            mode="tags"
            labelInValue={true}
            style={{ width: '100%', maxHeight: '300px', overflow: 'scroll' }}
            placeholder={placeholder}
            onChange={handleChange}
            optionLabelProp="label"
            optionFilterProp="label"
            allowClear={true}
            value={Selectvalue}
            notFoundContent="Aucun résultat"
            autoClearSearchValue={true}
            tokenSeparators={[',', ';']}
            options={(listClients || []).map((item: any) => {
                return {
                    label: `${item.firstName} ${item.lastName} - ${item.phoneNumber}`,
                    value: item.phoneNumber,
                };
            })}
        />
    );
};

export default CustomSelect;
